import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button, Spinner, Tab, Tabs } from "react-bootstrap";
import { api_url } from "../../constant/constant";
import { useTranslation } from "react-i18next";
import { showToast } from "../ShowToast/ToastNotification";
import Attachbyuserfilter from '../../Components/Attachbyuserfilter/Attachbyuserfilter';

const AddLcUserModal = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
    const [links, setLinks] = useState([]);
  
  const searchParams = new URLSearchParams(location.search);
  const LcUserModal_id = searchParams.get("LearningManager_id");

  const [isLoading, setIsLoading] = useState(false);
  const [data, setUsers] = useState([]);
  const [formData, setFormData] = useState({
    user_ids: [], 
  });
  const handleCheckboxChange = (id) => {
    const alreadySelected = formData.user_ids.includes(id.toString());
  
    let updated;
  
    if (alreadySelected) {
      updated = formData.user_ids.filter(uid => uid !== id.toString());
    } else {
      updated = [...formData.user_ids, id.toString()];
    }
  
    setFormData({ ...formData, user_ids: updated });
  };
  
  const handleSelectAll = (e) => {
    const { checked } = e.target;
  
    const currentPageIds = data.map(user => user.id.toString());
  
    if (checked) {
      const merged = [...new Set([...(formData.user_ids || []), ...currentPageIds])];
      setFormData({ ...formData, user_ids: merged });
    } else {
      const remaining = (formData.user_ids || []).filter(id => !currentPageIds.includes(id));
      setFormData({ ...formData, user_ids: remaining });
    }
  };
  
  
  
const fetchLcUserModal = async (url = null) => {
  try {
    const token = localStorage.getItem("userToken");
    const finalUrl = url 
      ? url 
      : `${api_url}/learning-campaigns-users/${LcUserModal_id}/get-avail-users`;

    const response = await fetch(finalUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,       
      },
    });

    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

    const result = await response.json();
    setUsers(result.data.data || []);
    setLinks(result.data.links);  

  } catch (error) {
    showToast(t("ErrorFetchingData"), "error");
  }
};


useEffect(() => {
    fetchLcUserModal();
}, []);

const handleChange = (event) => {
    const selectedValues = Array.from(event.target.selectedOptions, (option) => option.value);
    setFormData({ ...formData, user_ids: selectedValues });
};

const handleAddLcUserModal = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    // Ensure user_ids is an array
    if (!Array.isArray(formData.user_ids) || formData.user_ids.length === 0) {
        showToast(t("SelectAtLeastOneUser"), "error");
        setIsLoading(false);
        return;
    }

    try {
        const token = localStorage.getItem("userToken");
        const response = await fetch(`${api_url}/learning-campaigns-users/${LcUserModal_id}/attach-users`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ user_ids: formData.user_ids }), // Ensure correct data format
        });

        const result = await response.json();
        console.log("API Response:", result);

        if (response.ok) {
            showToast(t("UsersAddedSuccess"), "success");
            setFormData({ user_ids: [] }); // Clear form after success
            navigate(-1);
        } else {
            showToast(t(result.message) || t("ErrorOccurred"), "error");
        }
    } catch (error) {
        showToast(t("SomethingWentWrong"), "error");
    } finally {
        setIsLoading(false);
    }
};

  return (
    <div style={{ border: "1px solid #EAEAEA", borderRadius: "10px", padding: "26px", margin: "20px" }}>
      <div className="d-flex justify-content-end mb-3">
        <Button variant="primary" onClick={() => navigate(-1)} >{t('Back')}</Button>
      </div>

      <Tabs defaultActiveKey="Add Video" className="mb-3">
        <Tab eventKey="Add Video" title={t("AddLearningCampaignUser")}>
          <form onSubmit={handleAddLcUserModal}>
          <div className="mb-3">

<div className="mb-2">
  <input 
    type="checkbox"
    onChange={handleSelectAll}
    checked={
      data.length > 0 &&
      data.every(user => formData.user_ids.includes(user.id.toString()))
    }
  />
  <span style={{ marginLeft: "6px" }}>{t("SelectAllUsers")}</span>
</div>

<table className="table table-bordered">
  <thead>
    <tr>
      <th>{t("Select")}</th>
      <th>{t("Username")}</th>
      <th>{t("Email")}</th>
    </tr>
  </thead>
  <tbody>
    {data.length === 0 ? (
      <tr>
        <td colSpan="3">{t("Nousersavailable")}</td>
      </tr>
    ) : (
      data.map((user) => (
        <tr key={user.id}>
          <td>
            <input
              type="checkbox"
              checked={formData.user_ids.includes(user.id.toString())}
              onChange={() => handleCheckboxChange(user.id)}
            />
          </td>
          <td>{user.username}</td>
          <td>{user.email}</td>
        </tr>
      ))
    )}
  </tbody>
</table>
</div>



            <button type="submit" className="btn btn-primary" disabled={isLoading}>
              {isLoading ? (
                <>
                  <Spinner animation="border" size="sm" role="status" className="me-2" />
                  {t("Adding...")}
                </>
              ) : (
                t("AddUser")
              )}
            </button>
          </form>
          
      <div className="navigationWrapper">
        <ul>
          {links.map((link, index) => (
            <li
              key={index}
              className={`${link.active ? " active " : ""} ${
                link.url === null ? " disabled " : ""
              }`}
              onClick={
                link.url !== null
                  ? () => fetchLcUserModal(link.url)
                  : undefined
              }
            >
              <div dangerouslySetInnerHTML={{ __html: link.label }} />
            </li>
          ))}
        </ul>
      </div>
        </Tab>
        <Tab eventKey="AttachByuserfilter" title={t("AddUsersUsingQuery")}>
            <Attachbyuserfilter />
          </Tab>
      </Tabs>
      
    </div>
  );
};

export default AddLcUserModal;
